import { Routes } from "@angular/router";
import { SecureHomeComponent } from "./secure/landing/securehome.component";
import { PermissionsComponent } from "./secure/permissions/permissions.component";
import { ManageUsersComponent } from "./secure/manage-users/manage-users.component";
import { MyWorkComponent } from './secure/my-work/my-work.component';
import { ContractFormComponent } from "./entity-components/contract-form/contract-form.component";
import { BaaRecordComponent } from "./entity-components/baa-record/baa-record.component";
import { CertificateOfInsuranceComponent } from "./entity-components/certificate-of-insurance/certificate-of-insurance.component";
import { LegalEntityComponent } from "./entity-components/legal-entity/legal-entity.component";
import { SiteComponent } from "./entity-components/site/site.component";
import { ProvisionComponent } from "./entity-components/provision/provision.component";
import { AttachmentComponent } from "./entity-components/attachment/attachment.component";
import { CriticalDateComponent } from "./entity-components/critical-date/critical-date.component";
import { VendorComponent } from "./entity-components/vendor/vendor.component";
import { ContractListComponent } from "./list-all-pages/contract-list/contract-list.component";
import { BaaListComponent } from "./list-all-pages/baa-list/baa-list.component";
import { CoiListComponent } from "./list-all-pages/coi-list/coi-list.component";
import { ArchivedContractsListComponent } from './toolbar-components/archived-contracts-list/archived-contracts-list.component';

// Create New & Edit
import { NewAttachmentComponent } from "./create-new/new-attachment/new-attachment.component";
import { NewCoiFullPageComponent } from "./create-new/new-coi-full-page/new-coi-full-page.component";
import { NewProvisionComponent } from "./create-new/new-provision/new-provision.component";
import { NewSiteComponent } from "./create-new/new-site/new-site.component";
import { NewLegalEntityComponent } from "./create-new/new-legal-entity/new-legal-entity.component";
import { NewPersonFullPageComponent } from "./create-new/new-person-full-page/new-person-full-page.component";
import { NewVendorFullPageComponent } from "./create-new/new-vendor-full-page/new-vendor-full-page.component";
import { NewUserFullPageComponent } from "./create-new/new-user-full-page/new-user-full-page.component";
import { PersonComponent } from "./entity-components/person/person.component";
import { UserComponent } from "./entity-components/user/user.component";
import { NewCriticalDateComponent } from "./create-new/new-critical-date/new-critical-date.component";
import { NewBaaFullPageComponent } from "./create-new/new-baa-full-page/new-baa-full-page.component";
import { NewDocumentReviewComponent } from './create-new/new-document-review/new-document-review.component';
import { NewScheduledReportComponent } from './create-new/new-scheduled-report/new-scheduled-report.component';
import { ReportsComponent } from './toolbar-components/reports/reports.component';
import { ReportBuilderComponent } from './toolbar-components/report-builder/report-builder.component';
import { NewContractFullPageComponent } from './create-new/new-contract/new-contract.component';
import { NewAssessmentComponent } from './create-new/new-assessment/new-assessment.component';
import { NewWorkflowComponent } from './create-new/new-workflow/new-workflow.component';
import { WorkflowItemComponent } from './entity-components/workflow-item/workflow-item.component';
import { WorkflowsListComponent } from './toolbar-components/workflows-list/workflows-list.component';
import { NewRequestLandingComponent } from './shared/components/new-request-landing/new-request-landing.component';

import { DocumentReviewListComponent } from './toolbar-components/document-review-list/document-review-list.component';
import { PendingBaaChangesGuardGuard } from './secure/guards/pending-baa-changes-guard.guard';
import { PendingCoiChangesGuard } from './secure/guards/pending-coi-changes.guard';
import { PendingPartyChangesGuard } from './secure/guards/pending-party-changes.guard';
import { PendingPersonChangesGuard } from './secure/guards/pending-person-changes.guard';
import { PendingLegalEntityChangesGuard } from './secure/guards/pending-legal-entity-changes.guard';
import { PendingSiteChangesGuard } from './secure/guards/pending-site-changes.guard';
import { PendingImportantDateChangesGuard } from './secure/guards/pending-important-date-changes.guard';
import { PendingProvisionChangesGuard } from './secure/guards/pending-provision-changes.guard';
import { AttachmentsComponent } from "./toolbar-components/attachments/attachments.component";
import { ContractsComponent } from "./toolbar-components/contracts/contracts.component";
import { PeopleComponent } from "./toolbar-components/people/people.component";
import { UsersComponent } from "./toolbar-components/users/users.component";
import { PartiesComponent } from "./toolbar-components/parties/parties.component";
import { BaasComponent } from "./toolbar-components/baas/baas.component";
import { CoisComponent } from "./toolbar-components/cois/cois.component";
import { SitesListComponent } from './toolbar-components/sites-list/sites-list.component';
import { LegalEntitiesListComponent } from './toolbar-components/legal-entities-list/legal-entities-list.component';
import { CriticalDatesComponent } from "./toolbar-components/critical-dates/critical-dates.component";
import { ProvisionsListComponent } from "./toolbar-components/provisions-list/provisions-list.component";
import { AssessmentsComponent } from "./toolbar-components/assessments/assessments.component";
import { DocumentReviewFormComponent } from './secure/entity-forms/document-review-form/document-review-form.component';
import { ShowGraphResultsComponent } from './shared/show-results/show-graph-results/show-graph-results.component';
import { AttachmentListComponent } from './list-all-pages/attachment-list/attachment-list.component';
import { WaitForCompletionComponent } from "./shared/wait-for-completion/wait-for-completion.component";
import { AssessmentItemComponent } from './entity-components/assessment-item/assessment-item.component';
import { LogoutComponent } from './public/logout/logout.component'; 

// --- NEW IMPORTS FOR LOGIN AND AUTHENTICATION ---
import { LoginComponent } from './public/login/login.component';
import { PendingActivationComponent } from './public/pending-activation/pending-activation.component';
import { authGuard } from './auth.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'securehome',
        pathMatch: 'full'
    },
    {
        path: 'index.html',
        redirectTo: 'securehome',
        pathMatch: 'full'
    },
    {
      path: 'login',
      component: LoginComponent
    },
    {
      path: 'logout',
      component: LogoutComponent
    },
    {
      // Top-level (NOT a securehome child) so the activation gate never runs on it.
      path: 'pending-activation',
      component: PendingActivationComponent
    },
    {
        path: 'securehome',
        component: SecureHomeComponent, 
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'my-work', pathMatch: 'full' },
            { path: 'wait', component: WaitForCompletionComponent },
            {   
                path: 'my-work', 
                component: MyWorkComponent,
                data: { title: 'My Work' }
            },
            { path: 'archived-contracts', component: ArchivedContractsListComponent },
            { 
              path: 'contracts',
              component: ContractsComponent,
              data: { title: 'Contracts' }
            },
            { path: 'people', component: PeopleComponent, data: { title: 'People' } },
            { path: 'users', component: UsersComponent, data: { title: 'Users' } },
            { path: 'parties', component: PartiesComponent, data: { title: 'Vendors / Parties' } },
            { path: 'baas', component: BaasComponent, data: { title: 'BAAs' } },
            { path: 'cois', component: CoisComponent, data: { title: 'COIs' } },
            { path: 'critical-dates', component: CriticalDatesComponent, data: { title: 'Important Dates' } },
            { path: 'attachments', component: AttachmentsComponent, data: { title: 'Attachments' } },
            { path: 'provision-list', component: ProvisionsListComponent, data: { title: 'Provisions' } },
            { path: 'assessments', component: AssessmentsComponent, data: { title: 'Assessments' } },
            { path: 'sites', component: SitesListComponent, data: { title: 'Sites' } },
            { path: 'legal-entities', component: LegalEntitiesListComponent, data: { title: 'Legal Entities' } },
            // Reports
            { path: 'reports', component: ReportsComponent, data: { title: 'Reports' } },
            { path: 'report-builder', component: ReportBuilderComponent, data: { title: 'Report Builder' } },
            { path: 'report-builder/:id', component: ReportBuilderComponent, data: { title: 'Report Builder' } },
            // Timesheets — standalone lazy-loaded routes
            {
                path: 'timesheets',
                data: { title: 'Timesheets' },
                loadComponent: () => import('./modules/timesheets/timesheets-list/timesheets-list.component').then(m => m.TimesheetsListComponent)
            },
            {
                path: 'timesheet-spec/:id',
                loadComponent: () => import('./modules/timesheets/timesheet-spec/timesheet-spec.component').then(m => m.TimesheetSpecComponent)
            },
            {
                path: 'timesheet-edit/:id',
                loadComponent: () => import('./modules/timesheets/new-edit-timesheet/new-edit-timesheet.component').then(m => m.NewEditTimesheetComponent)
            },
            {
                path: 'timesheet-new',
                loadComponent: () => import('./modules/timesheets/new-edit-timesheet/new-edit-timesheet.component').then(m => m.NewEditTimesheetComponent)
            },
            // Timecards — standalone lazy-loaded routes (parallel domain to timesheets)
            {
                path: 'timecards',
                data: { title: 'Timecards' },
                loadComponent: () => import('./modules/timecards/timecards-list/timecards-list.component').then(m => m.TimecardsListComponent)
            },
            {
                path: 'timecard-edit/:id',
                loadComponent: () => import('./modules/timecards/new-edit-timecard/new-edit-timecard.component').then(m => m.NewEditTimecardComponent)
            },
            { path: 'document-review-list', component: DocumentReviewListComponent },
            { path: 'permissions', component: PermissionsComponent, data: { title: 'Permissions' } },
            { path: 'manage-users', component: ManageUsersComponent, data: { title: 'Manage Users' } },
            {
                path: 'proxy-assignments',
                data: { title: 'Proxy Assignments' },
                loadComponent: () => import('./secure/proxy-assignments/proxy-assignments.component').then(m => m.ProxyAssignmentsComponent)
            },
            { path: 'contract-list', component: ContractListComponent },
            { path: 'baa-list', component: BaaListComponent },
            { path: 'coi-list', component: CoiListComponent },
            { path: 'contract', component: ContractFormComponent },
            { path: 'contract/:id', component: ContractFormComponent },
            { path: 'doc-review/:id', component: DocumentReviewFormComponent },
            { path: 'baa', component: BaaRecordComponent },
            { path: 'baa/:id', component: BaaRecordComponent },
            { path: 'coi', component: CertificateOfInsuranceComponent },
            { path: 'coi/:id', component: CertificateOfInsuranceComponent },
            { path: 'legal-entity', component: LegalEntityComponent },
            { path: 'legal-entity/:id', component: LegalEntityComponent },
            { path: 'site', component: SiteComponent },
            { path: 'site/:id', component: SiteComponent },
            { path: 'provision', component: ProvisionComponent },
            { path: 'provision/:id', component: ProvisionComponent },
            { path: 'provisions', component: ProvisionsListComponent },
            { path: 'attachment', component: AttachmentComponent },
            { path: 'attachment-list', component: AttachmentListComponent },
            { path: 'graph-result-list', component: ShowGraphResultsComponent },
            { path: 'critical-date', component: CriticalDateComponent },
            { path: 'vendor', component: VendorComponent },
            { path: 'vendor/:id', component: VendorComponent },
            { path: 'person', component: PersonComponent },
            { path: 'person/:id', component: PersonComponent },
            { path: 'user', component: UserComponent },
            { path: 'user/:id', component: UserComponent },
            { path: 'assessment', component: AssessmentItemComponent },
            { path: 'assessment/:id', component: AssessmentItemComponent },
            { path: 'new-assessment', component: NewAssessmentComponent },
            { path: 'new-assessment/:id', component: NewAssessmentComponent },
            // No bare 'workflow' route: WorkflowItemComponent only loads inside
            // `if (params['id'])`, so without an id it rendered a spinner forever.
            { path: 'workflow', redirectTo: 'workflows', pathMatch: 'full' },
            { path: 'workflow/:id', component: WorkflowItemComponent },
            { path: 'workflows', component: WorkflowsListComponent },
            { path: 'new-request', component: NewRequestLandingComponent },
            { path: 'new-workflow', component: NewWorkflowComponent },
            { path: 'new-workflow/:id', component: NewWorkflowComponent },
            { path: 'new-attachment', component: NewAttachmentComponent },
            { path: 'new-document-review', component: NewDocumentReviewComponent },
            { path: 'new-scheduled-report', component: NewScheduledReportComponent },
            { path: 'new-coi-full-page', component: NewCoiFullPageComponent, data: { title: 'New COI' } },
            { path: 'new-coi/:id', component: NewCoiFullPageComponent },
            { path: 'new-provision', component: NewProvisionComponent, canDeactivate: [PendingProvisionChangesGuard] },
            { path: 'new-provision/:id', component: NewProvisionComponent, canDeactivate: [PendingProvisionChangesGuard] },
            { path: 'new-site', component: NewSiteComponent},
            { path: 'new-legal-entity', component: NewLegalEntityComponent },
            { path: 'new-vendor-full-page', component: NewVendorFullPageComponent, data: { title: 'New Vendor' } },
            { path: 'new-vendor-full-page/:id', component: NewVendorFullPageComponent },
            { path: 'new-person-full-page', component: NewPersonFullPageComponent, data: { title: 'New Person' } },
            { path: 'new-person-full-page/:id', component: NewPersonFullPageComponent },
            { path: 'new-user', component: NewUserFullPageComponent },
            { path: 'new-user/:id', component: NewUserFullPageComponent },
            { path: 'new-critical-date', component: NewCriticalDateComponent, data: { title: 'New Important Date' } },
            { path: 'new-baa-full-page', component: NewBaaFullPageComponent, data: { title: 'New BAA' } },
            { path: 'new-baa/:id', component: NewBaaFullPageComponent },
            { path: 'new-contract', component: NewContractFullPageComponent, data: { title: 'New Contract' } },
            { path: 'new-contract/:id', component: NewContractFullPageComponent, data: { title: 'New Contract' } }
        ]
    },
    // --- CATCH-ALL REDIRECT TO LOGIN PAGE ---
    {
      path: '**',
      redirectTo: 'login'
    }
];

export const appRoutingProviders: any[] = [];